import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { PwaUpdateService } from '../../services/pwa-update.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-pwa-update-banner',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './pwa-update-banner.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pwa-update-banner.scss',
})
export class PwaUpdateBanner {
  private updateService = inject(PwaUpdateService);
  showUpdateBanner$: Observable<boolean> = this.updateService.hasUpdate$;

  update(): void {
    this.updateService.refreshApp();
  }

  dismiss(): void {
    this.updateService.dismissUpdate();
  }
}
